import AddDeleteTagModal from './AddDeleteTagModal';

export default AddDeleteTagModal;
